/** Owner inquiry decision workspace display + patch helpers. */

export const OWNER_REVIEW_SECTION_TEST_ID = 'owner-inquiry-review-section';
export const OWNER_REVIEW_SAVE_BTN_TEST_ID = 'owner-review-save-btn';

export const SHORTLIST_STATUS_NONE = 'none';
export const SHORTLIST_STATUS_INTERESTED = 'interested';
export const SHORTLIST_STATUS_MAYBE = 'maybe';
export const SHORTLIST_STATUS_NOT_A_FIT = 'not_a_fit';
export const SHORTLIST_STATUS_SELECTED_CANDIDATE = 'selected_candidate';

export const SHORTLIST_STATUS_OPTIONS = [
  { value: SHORTLIST_STATUS_NONE, labelKey: 'owner.review_shortlist_none' },
  { value: SHORTLIST_STATUS_INTERESTED, labelKey: 'owner.review_shortlist_interested' },
  { value: SHORTLIST_STATUS_MAYBE, labelKey: 'owner.review_shortlist_maybe' },
  { value: SHORTLIST_STATUS_NOT_A_FIT, labelKey: 'owner.review_shortlist_not_a_fit' },
  {
    value: SHORTLIST_STATUS_SELECTED_CANDIDATE,
    labelKey: 'owner.review_shortlist_selected_candidate',
  },
];

export const GUIDED_QUESTION_DEFINITIONS = [
  { id: 'stay_dates_fit', labelKey: 'owner.review_q_stay_dates_fit' },
  { id: 'guest_count_fit', labelKey: 'owner.review_q_guest_count_fit' },
  { id: 'pet_policy_fit', labelKey: 'owner.review_q_pet_policy_fit' },
  { id: 'parking_or_access_needs', labelKey: 'owner.review_q_parking_or_access_needs' },
  { id: 'profile_complete', labelKey: 'owner.review_q_profile_complete' },
  { id: 'communication_clear', labelKey: 'owner.review_q_communication_clear' },
  { id: 'viewing_scheduled', labelKey: 'owner.review_q_viewing_scheduled' },
  { id: 'viewing_completed', labelKey: 'owner.review_q_viewing_completed' },
  { id: 'follow_up_needed', labelKey: 'owner.review_q_follow_up_needed' },
  { id: 'owner_reasoning', labelKey: 'owner.review_q_owner_reasoning' },
];

export const GUIDED_QUESTION_IDS = GUIDED_QUESTION_DEFINITIONS.map((q) => q.id);

export const PATCH_ALLOWED_FIELDS = Object.freeze(['shortlist_status', 'private_notes', 'guided_answers']);

export function ownerReviewWorkspaceTestId(inquiryId) {
  return `owner-review-${inquiryId}`;
}

export function defaultReviewFormState() {
  return {
    shortlistStatus: SHORTLIST_STATUS_NONE,
    privateNotes: '',
    guidedAnswers: {},
  };
}

export function reviewFormStateFromApi(review) {
  const guidedAnswers = { ...(review?.guided_answers || {}) };
  return {
    shortlistStatus: review?.shortlist_status || SHORTLIST_STATUS_NONE,
    privateNotes: review?.private_notes || '',
    guidedAnswers,
  };
}

export function buildOwnerReviewPatchPayload({ shortlistStatus, privateNotes, guidedAnswers }) {
  const payload = {
    shortlist_status: shortlistStatus,
    private_notes: privateNotes,
    guided_answers: { ...guidedAnswers },
  };

  const extraKeys = Object.keys(payload).filter((key) => !PATCH_ALLOWED_FIELDS.includes(key));
  if (extraKeys.length > 0) {
    throw new Error(`Patch payload contains disallowed fields: ${extraKeys.join(', ')}`);
  }

  return payload;
}

export function parseOwnerReviewGetResponse(data) {
  return {
    persisted: Boolean(data?.persisted),
    review: data?.review || null,
  };
}
